import { __decorate, __metadata } from 'tslib';
import { NotEnumerable, getClass } from '@tencent/workbench-core';
import { ProviderStorable } from '../../core/provider-storable.js';
import { ActionPointRegistry } from '../../registries/action-point-registry.js';

/**
 * @internal
 */
class ControllerProvider extends ProviderStorable {
    constructor(provide) {
        super(provide);
        this.controllerMiddlewares = {
            useBefore: [],
            use: [],
            useAfter: [],
        };
        this.toolbarItems = [];
        this.mobileToolbarItems = [];
        this.menuItems = [];
        this.mobileMenuItems = [];
        this.statusbarItems = [];
        this.contextMenuItems = [];
        this.mobileContextMenuItems = [];
        this.keymapConfigs = [];
        this.titlebarItems = [];
        this.mobileTitlebarItems = [];
        this.mobileActionButtons = [];
        this.type = 'controller';
    }
    get middlewares() {
        return this.controllerMiddlewares;
    }
    set middlewares(middlewares) {
        Object.keys(middlewares).forEach((key) => {
            this.controllerMiddlewares[key] = this.controllerMiddlewares[key].concat(middlewares[key]);
        });
    }
    get actionPoints() {
        return ActionPointRegistry.getActionPoints(getClass(this.provide));
    }
}
__decorate([
    NotEnumerable(),
    __metadata("design:type", Object)
], ControllerProvider.prototype, "controllerMiddlewares", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", String)
], ControllerProvider.prototype, "name", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], ControllerProvider.prototype, "middlewares", null);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], ControllerProvider.prototype, "actionPoints", null);

export { ControllerProvider };
//# sourceMappingURL=controller-provider.js.map
